export const SET_ABOUT_POPUP = 'SET_ABOUT_POPUP';
export const SET_INFO_POPUP = 'SET_INFO_POPUP';
export const SET_IMAGE_POPUP = 'SET_IMAGE_POPUP';
export const SET_TERM_POPUP = 'SET_TERM_POPUP';
export const SET_NAVIGATION_POPUP = 'SET_NAVIGATION_POPUP';
export const SET_PAGE_ID = 'SET_PAGE_ID';
export const SET_PAGE_ID_BACK = 'SET_PAGE_ID_BACK';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SEARCH_OPEN = 'SET_SEARCH_OPEN';
